
<template>
    <v-content>
        <v-card color="#FFFFFF" width="100%" class="stickytop" flat>
                <div  id="logobar" style="text-align: center;"><a href="/Welcome"><img contain height="80px" src="@/assets/logo.png"></a></div>
                    
            </v-card>
          <v-toolbar src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" id="belowlogobar" dark class="secondary stickytop2" width="100%" flat>
          <v-icon dark  @click="IntranetViewToggle">
              mdi-repeat
            </v-icon>
             <!-- class="hidden-md-and-up" -->
          
          <v-toolbar-title>
            Intranet Menu
          </v-toolbar-title>
          <v-layout v-if="typeof UserRecord.id !== 'undefined'">
      
        <!-- <div id="notificationbar"> -->
          <v-list dark class="transparent">
                  <v-list-item>
                        <v-menu offset-y :close-on-content-click="false" bottom left>
                          <template v-slot:activator="{ on }">
                            <v-badge color="pop" overlap
                              dark>

                              <v-icon
                              dark
                              v-on="on">
                              mdi-bell-check
                            </v-icon>

                            <span slot="badge"> {{UnreadNotifications.length}} </span>
                            </v-badge>
                          </template>

                          <v-tabs dark>
                                <v-tab>Unread</v-tab>
                                <v-tab-item>
                                <v-list light v-if="UnreadNotifications.length>0">
                                  <h3 class="viewingnotificationheader">New Notifications</h3><br>
                                  <v-list-item v-for="notification in UnreadNotifications" :key="notification.itemObjKey" :class="{newbasicoutlined: !notification.Read}" @click="NotificationRead(notification)">
                                      <v-list-item-content class="notificationheader">
                                      {{notification.Header}}
                                      <p class="notificationcontent">{{notification.Message}}<span class="tooltiptext"><h4>{{notification.CreatorFullName}}</h4>{{notification.Content.substr(0, 50)}}</span></p>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                <v-list class="viewingnotification" light v-if="UnreadNotifications.length===0">
                                  <h3 class="viewingnotificationheader">New Notifications</h3><br>
                                  <v-list-item>
                                    <v-list-item-content class="notificationheader">
                                      There are no new notifications<br>
                                      <p class="notificationcontent">Click on the "Read" tab to see Read notifications</p>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                </v-tab-item>
                                <v-tab>Read</v-tab>
                                <v-tab-item>
                                <v-list class="viewingnotification" light v-if="ReadNotifications.length>0">
                                  <h3 class="viewingnotificationheader">Read Notifications</h3><br>
                                  <v-list-item v-for="notification in ReadNotifications" :key="notification.itemObjKey" :class="{newbasicoutlined: notification.Read}">
                                    <v-list-item-content class="notificationheader">
                                      {{notification.Header}}
                                      <p class="notificationcontent">{{notification.Message}}<span class="tooltiptext"><h4>{{notification.CreatorFullName}}</h4>{{notification.Content.substr(0, 50)}}</span></p>
                                    </v-list-item-content>
                                    <v-list-item-content>
                                      <v-btn small @click="MarkasUnread(notification)">Mark Unread</v-btn><v-btn small @click="ViewItem(notification)">View</v-btn>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                <v-list class="viewingnotification" light v-if="ReadNotifications.length===0">
                                  <h3 class="viewingnotificationheader">Read Notifications</h3><br>
                                  <v-list-item>
                                    <v-list-item-content class="notificationheader">
                                      There are no Read notifications<br>
                                      <p class="notificationcontent">Click on the "Unread" tab to see New notifications</p>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                </v-tab-item>
                              </v-tabs>

                            </v-menu>
                      </v-list-item>                       
                  </v-list>
                  <v-list dark class="transparent">
                <v-list-item>
                  <v-menu
                      bottom
                      left
                      offset-y
                      :close-on-content-click="false"
                      >
                      <template v-slot:activator="{ on }">
                      <v-avatar v-on="on">
                        <img v-if="UserRecord.Profile_Photo "
                          :src="UserRecord.Profile_Photo "              
                        >
                        <img v-if="!UserRecord.Profile_Photo "
                          src="@/assets/blank-profile-picture-973460_640.png"              
                        >
                      </v-avatar>
                      </template>
                      <v-list>
                        <v-list-item :to="'/MyProfile'">
                        <v-list-item-avatar>
                          <img v-if="UserRecord.Profile_Photo "
                          :src="UserRecord.Profile_Photo "              
                        >
                        <img v-if="!UserRecord.Profile_Photo "
                          src="@/assets/blank-profile-picture-973460_640.png"              
                        >
                        </v-list-item-avatar>
                          <v-list-item-content>
                            View My Profile
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="ActivateTicketLog()">
                        <v-list-item-avatar>
                        <v-icon>mdi-ticket-confirmation</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            Log Ticket 
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="ConfirmlogoutFromFirebase">
                        <v-list-item-avatar>
                        <v-icon>mdi-exit-to-app</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            Sign Out 
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                </v-list-item>
        </v-list>

          </v-layout>

          <v-spacer></v-spacer>
          <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer" />
         <v-list dense dark class="transparent hidden-sm-and-down">
             <v-list-item>
                 <v-list-item-content v-for="item in FinalRender" :key="item.itemObjKey">
                         <v-btn small  :to="item.Path" v-if="!item.SubItems || !item.SubItems.length" text>{{item.DisplayName}}</v-btn>
                         <v-menu
                            v-if="item.SubItems && item.SubItems.length>0"
                            bottom
                            left
                            offset-y
                            :close-on-content-click="false"
                        >
                            <template v-slot:activator="{ on }">
                            <v-btn
                                
                                text
                                small
                                class="align-self-center mr-4"
                                v-on="on"
                            >
                            {{item.DisplayName}}
                                <v-icon right>mdi-menu-down</v-icon>
                            </v-btn>
                            </template>
                            <v-list dense class="grey lighten-3 submenuitem">
                            <v-list-item
                                v-for="subitem in item.SubItems"
                                :key="subitem.itemObjKey"
                            >                            
                                <v-btn depressed small width="100%"  :to="subitem.Path" v-if="!subitem.SubChildren || !subitem.SubChildren.length" text>{{subitem.DisplayName}}</v-btn>
                                <v-list-group
                                 v-if="subitem.SubChildren && subitem.SubChildren.length"
                              >
                                <template v-slot:activator>
                                  <v-btn depressed small width="100%"  text>{{subitem.DisplayName.toUpperCase()}}</v-btn>
                                </template>
                               
                                    <v-list-item
                                        v-for="subsub in subitem.SubChildren"
                                        :key="subsub.itemObjKey"
                                        :href="subsub.Path"
                                    >                                    
                                        <span>{{ subsub.DisplayName.toUpperCase() }}</span>
                                    </v-list-item>
                                </v-list-group>
                                
                            
                            </v-list-item>
                            </v-list>
                        </v-menu>
                    
                 </v-list-item-content>
             </v-list-item>
         </v-list>
         </v-toolbar>
         <v-system-bar window dark color="primary" class="stickytop3">
            <v-icon>mdi-lock-open-variant-outline</v-icon>
            <span v-if="UserRecord">Signed in as {{UserRecord.Full_Name}}</span>
            <v-spacer></v-spacer>
            <v-icon>mdi-file-find-outline</v-icon>
           <input clearable class="searchinput" v-model="search" type="text" id="fname" name="fname" @keydown.enter="ActivateSearch()">
            <v-icon>mdi-face</v-icon>
            <v-icon>mdi-message</v-icon>
          </v-system-bar>
          <v-navigation-drawer temporary class="waytop"
          src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      fixed :dark="true" right  v-model="drawer" color="#0B63BD">
      <v-list>
        <div v-for="item in FinalRender" :key="item.title">
          <v-list-item v-if="!item.SubItems || item.SubItems.length>0" :to="item.Path">
          <v-list-item-content>
            <v-list-item-title :to="item.Path">{{ item.DisplayName}}
            </v-list-item-title>
            </v-list-item-content>
           
          </v-list-item>
            <v-list-group
              v-if="item.SubItems && item.SubItems.length"
              >
                <template v-slot:activator>
                  <v-list-item-title>{{item.DisplayName}}</v-list-item-title>
                </template>
                <div v-for="subsub in item.SubItems"
                        :key="subsub.itemObjKey">
                    <v-list-item class="mx-3"
                        
                        :to="subsub.Path"
                    >                                   
                        <v-list-item-title>{{ subsub.DisplayName }}</v-list-item-title>
                    </v-list-item>
                    
                </div>
              </v-list-group>
          </div>
      </v-list>

    </v-navigation-drawer>
    </v-content>
</template>


<script>
import firebase from 'firebase';
import db from '@/main'

export default {
  props: ['UserRecord'],
  components: {},
  data() {
    return {
      Notifications: [],
      drawer:false,
      SearchView: false,
      search: '',
      pubitems: [
      ],
      login: {
          icon: 'mdi-door-open',
          title: 'Login',
          to: '/Login',
          target: 'self',
          color: 'pop--text'
        },
    }
  },
  computed: {
     FinalRender(){
         return this.pubitems.map(item => {
             return item
         })
     },
     UnreadNotifications(){
      return this.Notifications.filter(notificaton => {
        return !notificaton.Read === true
      })
    },
    ReadNotifications(){
      return this.Notifications.filter(notificaton => {
        return notificaton.Read === true
      })
    }
    },

  created() {
    let query = db.collection('notifications').where('Ownerid', '==', this.UserRecord.id)
    this.GetUserNotifications(query)
   
  },
  watch:{
        'search' (){
            this.CheckActivateSearch()
        }
  },
  methods: {
    IntranetViewToggle(){
      confirm('This will take you to the data version of the App, do you want to continue?') &&
        this.$emit('IntranetViewToggle',false)
      },
      CancelSubmitSystemTicket(){
      this.TicketLog = false
    },
      ActivateTicketLog(){
        this.UsersArray = [this.UserRecord]
        this.TicketLog = true
      },
    GetUserNotifications(query){
      query.get().then(res => {

      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.Notifications.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    })
    },


     NotificationRead(notification){
      if(notification.Read === false){
       db.collection('notifications').doc(notification.id).update({
        Read: true
      })
      let notificationIndex = this.Notifications.indexOf(notification)
      this.Notifications[notificationIndex].Read = true
      this.$router.push(notification.Path)

      }

    },
    ViewItem(notification){
      this.$router.push(notification.Path)
    },

    MarkasUnread(notification){
      if(notification.Read === true && notification.Type === 'Task Created'){
       db.collection('notifications').doc(notification.id).update({
        Read: false
      })
      let notificationIndex = this.Notifications.indexOf(notification)
      this.Notifications[notificationIndex].Read = false


      }
    },

    ConfirmlogoutFromFirebase(){
      confirm('Are you sure you want to log out?') && this.logoutFromFirebase()
    },

    logoutFromFirebase () {
      this.Notifications = []
      this.UserRecord = {}
      this.$store.dispatch('signOutAction')
      this.$router.replace('/Login')
    },
    CheckActivateSearch(){
      console.log(this.search === '')
      console.log(this.SearchView)
      if(this.search === '' && this.SearchView){
        console.log('conditions met bro')
      this.$emit('DeactivateSearch')
      this.SearchView = false
      }
      
    },
    ActivateSearch(){    
      this.$emit('DeactivateSearch')
      console.log(this.search) 
      this.SearchView = true
      this.$emit('ActivateSearch',this.search)
    },
    
  }

}
</script>

<style>
.notifications .viewingnotification {

  width: 250px;
  outline: 1px solid #dedee9;
  color: black;
  text-align: center;
  padding: 10px;
  font-size: 15px;



  /* Position the tooltip */
  position: absolute;
  z-index: 100;
}
.notificationcontent {
  font-size: 12px;
  color: black;
  text-align: left;
}
.notificationcontent .tooltiptext {
  visibility: hidden;
  min-width: 250px;
  width: auto;
  background-color: rgb(0, 153, 255);
  color: white;
  text-align: center;
  border-radius: 6px;
  font-size: 15px;
  padding: 15px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 100;
}

.notificationcontent:hover .tooltiptext {
  visibility: visible;
}
.notificationheader {
  color: black;
  text-align: left;
}
.viewingnotificationheader{
  align-self: left;
  border: 1px solid #dedee9;
  padding: 10px;
  background-color: rgb(0, 153, 255);
  color: white;
}
.waytop{
  z-index: 100;
}
.searchinput{
  background-color: white;
  color: #474747;
}
.notifications .viewingnotification {

  width: 250px;
  outline: 1px solid #dedee9;
  color: black;
  text-align: center;
  padding: 10px;
  font-size: 15px;



  /* Position the tooltip */
  position: absolute;
  z-index: 100;
}
.notificationcontent {
  font-size: 12px;
  color: black;
  text-align: left;
}
.notificationcontent .tooltiptext {
  visibility: hidden;
  min-width: 250px;
  width: auto;
  background-color: rgb(0, 153, 255);
  color: white;
  text-align: center;
  border-radius: 6px;
  font-size: 15px;
  padding: 15px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 100;
}

.notificationcontent:hover .tooltiptext {
  visibility: visible;
}
.notificationheader {
  color: black;
  text-align: left;
}
.viewingnotificationheader{
  align-self: left;
  border: 1px solid #dedee9;
  padding: 10px;
  background-color: rgb(0, 153, 255);
  color: white;
}
/* .notificationtabs{
  padding: 150px;
  margin-top: 1000px;
} */
/* .notifications{
  padding: 150px;
  margin-top: 100px;
} */
.basicoutlined{
  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
  color: black
}
.newbasicoutlined{

  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
}
.outline {

  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
}
/* #notificationbar {
  position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 72%;
    height: 30%;
    margin: auto;
}
#navbaravatar{
  position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 1;
    width: 70%;
    height: 30%;
    margin: auto;
} */
.submenuitem{
    font-size: 12px;
}
.stickytop {
  top: 30px;
  z-index: 4
}
.stickytop2 {
  position: fixed;
  top: 100px;
  z-index: 4
}
.stickytop3{
  position: fixed;
  width: 100%;
  z-index: 4
}
</style>
    